module.exports = __webpack_public_path__ + "img/pdf-icon-hover.dc0f0e27.svg";